// Module
var code = `<sub-header header="'Amortization schedule report'"></sub-header>
<report-approvals-filters
  hide-date="true"
  approved-by-name="\$ctrl.approvedByName"
  checked-by-name="\$ctrl.checkedByName"
  display-report="\$ctrl.displayReport"
>
</report-approvals-filters>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/amortization-schedule-report/amortization-schedule-report.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;